module.exports = __webpack_public_path__ + "src/img/remark.4da279fd.svg";